import { render, staticRenderFns } from "./gallerySlider.vue?vue&type=template&id=e82cf22e"
import script from "./gallerySlider.vue?vue&type=script&lang=js"
export * from "./gallerySlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports